import React from 'react';
import './App.css';

// Import AdminPanel component directly from the source file
import AdminPanel from './index.jsx';

function App() {
  return (
    <div className="App">
      <AdminPanel />
    </div>
  );
}

export default App;
